module.exports = __webpack_public_path__ + "img/5.01.thmb.a2c20180.jpg";